import React, {RefObject} from 'react';
import {QRCodeCanvas} from 'qrcode.react';
import QrZoomScanEffects from './QrZoomScanEffects';
import QrZoomTicketStatus from './QrZoomTicketStatus';
import * as css from './QrZoom.css';

interface QrZoomContentProps {
    barcode: string;
    qid: number;
    ticketLabel?: string;
    reduceMotion: boolean | null;
    canceled?: boolean;
    scanned: boolean;
    scanTs?: number;
    isScanning: boolean;
    isPop: boolean;
    zoomQrRef: RefObject<HTMLDivElement>;
}

function QrZoomContent({
    barcode,
    qid,
    ticketLabel,
    reduceMotion,
    canceled,
    scanned,
    scanTs,
    isScanning,
    isPop,
    zoomQrRef,
}: QrZoomContentProps): React.ReactElement {
    return (
        <>
            <css.qrWrap ref={zoomQrRef}>
                <css.qrCanvas $isScanning={isScanning}>
                    <QRCodeCanvas value={barcode} size={400} />
                </css.qrCanvas>
                {!reduceMotion && <QrZoomScanEffects isScanning={isScanning} />}
            </css.qrWrap>
            {ticketLabel && (
                <css.ticketNo>
                    {ticketLabel} • {qid}
                </css.ticketNo>
            )}
            <QrZoomTicketStatus scanned={scanned} canceled={canceled} scanTs={scanTs} isPop={isPop} />
        </>
    );
}

export default QrZoomContent;
